import { v4 as uuid } from 'uuid';
import { format } from 'date-fns';
import { addDoubleQuotes, addQuotes, toStringify } from '../utils/smartutils';
import {
  COMMUNICATION_TYPE,
  ATTACHMENT_TYPES,
  VIMEO_VIDEO_STATUS,
  AVAILABLE_TO,
  DAYS_REPEAT_STRING,
  RELATION_OBJECT_TYPE,
} from '../utils/constants';

function getQuestionAnswers(question) {
  const answers = question.map((answer) => ({
    id: 0,
    description: answer.description,
    hashId: answer.hashId,
    correct: answer.correct,
    trueOrFalse: answer.trueOrFalse ? answer.trueOrFalse : null,
    deleted: false,
    active: true,
    selected: false,
  }));
  return answers;
}

export function communicationFindByFilterQuery(filter) {
  const classes = filter.classes ? filter.classes.map(({ id }) => id) : [];
  const students = filter.students ? filter.students.map(({ id }) => id) : [];
  const employees = filter.employees
    ? filter.employees.map(({ id }) => id)
    : [];

  const query = `query {
    communicationListByFilter(
      filter: {
        id: 0
        classes: ${JSON.stringify(classes).replace(/"([^(")"]+)":/g, '$1:')},
        students: ${JSON.stringify(students).replace(/"([^(")"]+)":/g, '$1:')},
        employees: ${JSON.stringify(employees).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        periodType: "${!filter.onlySent ? filter.periodType : ''}"
        initialPeriod: ${filter.initialPeriod.getTime()}
        finalPeriod: ${filter.finalPeriod.getTime()}
        communicationType: "${
          filter.communicationType ? filter.communicationType.value : ''
        }"
        onlySent: ${filter.onlySent}
      }
    ) {
      id
      editable
      title
      htmlContent
      content
      sent
      scheduled
      type
      updaterName
      creatorName
      createdAtMili
      sentAt
      dueDateMili
      scheduledTo
      scheduledToHour
      hashId
      examHeader {
        teacher {
          id
          name
        }
        courseStep {
          course {
            id
       minNote
       maxNote
          }
        }
        subject {
          id
          name
        }
        evaluationWay { name }
        weight
        evaluationType
      }
      taskHeader {
        id
        teacher {
          id
          name
        }
        subject {
          id
          name
        }
      }
    }
  }
  `;
  return query;
}

export function communicationFindByIdTitle() {
  const query = `query {
    communicationListByFilter(
      filter: {
        id: 0
        classes: [],
        students: [],
        employees: [],
        periodType: "DELIVERY"
        initialPeriod: 0
        finalPeriod: ${Date.now()}
        communicationType: "AUTH"
        onlySent: false
      }
    ) {
      id
      title
      }    
  }`;

  return query;
}

export function communicationFindByIdQuery(id) {
  const query = `{
      communicationListByFilter(filter: { id: ${id} }) {
        id
        editable
        title
        htmlContent
        content
        sent
        scheduled
        type
        createdAtMili
        sentAt
        dueDateMili
        scheduledTo
        scheduledToHour
        hashId
        relatedObjects {
          id
          description
          identifier
          type
          quantity
        }
        analysisItems {
          id,
          analysisItem {
            id
            name
            order
            active
          }
          analysisName
          analysisContent
        }
        occurrenceHeader {
          id
          occurrenceDateMilli
          occurrenceHour
          occurrenceType  { id name }
        }
        taskHeader {
          id
          teacher {
            id
            name
          }
          subject {
            id
            name
          }
        }
        visibleTo
        examHeader {
          id
          cycle
          courseStep {
            id
            fullName 
            label
            value
            cycleQuantity
            course {
              id
              name
              label
              value
            }
          }
          evaluationWay { 
            id 
            name 
            label
            value 
          }
          weight
          evaluationType          
          examType
          teacher {
            id
            name
            label
            value
          }
          subject {
            id
            name
            label
            value
          }
        }
      }
}`;
  return query;
}

export function communicationFileListByCommunicationId(id) {
  const query = `{
    communicationFileListByCommunicationId(communicationId: ${id}){
         id,
         communicationId,
         fileName,
         fileType,
         fileId,
         fileUrl,
         thumbFileId,
         thumbFileUrl,
         order,
         status
    }
}`;

  return query;
}

export function communicationSaveMutation(
  values,
  files,
  filesAlreadyToUploaded
) {
  let filesId = [];
  const recipients = values.recipients.map((item) => ({
    id: item.id,
    type: item.type,
    quantity: item.quantity,
  }));
  let planHeader = { id: 0 };
  if (values.type === COMMUNICATION_TYPE.PLAN) {
    const subject = {
      ...values.planHeader.subject,
      termFilterId: 0,
      filterByStatus: false,
      updaterId: 0,
      subjectLevelFilterId: 0,
      active: true,
    };
    const bnccSkill = values.planHeader.bnccSkills.map((item) => ({
      id: 0,
      bnccSkill: {
        id: item.value,
        name: item.label,
        description: item.description,
      },
    }));

    delete subject.value;
    delete subject.label;

    planHeader = {
      id: values.planHeader && values.planHeader.id ? values.planHeader.id : 0,
      subject: { ...subject },
      startDate: values.planHeader.rangeDate.startDate,
      endDate: values.planHeader.rangeDate.endDate,
      theme: values.planHeader.theme,
      generalObjective: values.planHeader.generalObjective,
      contents: values.planHeader.contents,
      procedureTaken: values.planHeader.procedureTaken,
      resources: values.planHeader.resources,
      evaluation: values.planHeader.evaluation,
      bnccSkills: bnccSkill,
      generalObservation: values.planHeader.generalObservation,
    };
  }
  let taskHeader = { id: 0, taskEnded: 0 };
  if (values.type === COMMUNICATION_TYPE.ACTIVITY) {
    const teacher = {
      ...values.taskHeader.teacher,
      usuarioChatInterno: false,
      ativo: true,
      filterByStatus: false,
      pedagogicAdm: false,
      updaterId: 0,
      usuarioChat: false,
      active: true,
    };
    const subject = {
      ...values.taskHeader.subject,
      termFilterId: 0,
      filterByStatus: false,
      updaterId: 0,
      subjectLevelFilterId: 0,
      active: true,
    };
    delete teacher.value;
    delete teacher.label;

    delete subject.value;
    delete subject.label;

    taskHeader = {
      id: values.taskHeader && values.taskHeader.id ? values.taskHeader.id : 0,
      teacher: { ...teacher },
      subject: { ...subject },
      taskEnded: 0,
    };
  }

  let examHeader = { id: 0, taskEnded: 0, cycle: 0 };
  if (values.type === COMMUNICATION_TYPE.EXAM) {
    const teacher = {
      ...values.examHeader.teacher,
      usuarioChatInterno: false,
      ativo: true,
      filterByStatus: false,
      pedagogicAdm: false,
      updaterId: 0,
      usuarioChat: false,
      active: true,
    };
    const subject = {
      ...values.examHeader.subject,
      termFilterId: 0,
      filterByStatus: false,
      updaterId: 0,
      subjectLevelFilterId: 0,
      active: true,
    };

    const courseStep = {
      ...values.examHeader.courseStep,
      course: {
        ...values.examHeader.courseStep.course,
        excluded: false,
        updaterId: 0,
        useGridSchedule: true,
        active: true,
      },
    };

    delete teacher.value;
    delete teacher.label;

    delete subject.value;
    delete subject.label;

    delete courseStep.value;
    delete courseStep.label;
    delete courseStep.lowercaseLabel;
    delete courseStep.course.value;
    delete courseStep.course.label;

    const evaluationWay = {
      ...values.examHeader.evaluationWay,
      filterByStatus: false,
      updaterId: 0,
      active: true,
    };

    delete evaluationWay.value;
    delete evaluationWay.label;

    examHeader = {
      ...examHeader,
      id: values.examHeader && values.examHeader.id ? values.examHeader.id : 0,
      teacher: { ...teacher },
      subject: { ...subject },
      evaluationWay: { ...evaluationWay },
      cycle: values.examHeader.cycle.value,
      examType: values.examHeader.examType,
      weight: parseInt(values.examHeader.weight, 0),
      evaluationType: values.examHeader.evaluationType.value,
      courseStep: { ...courseStep },
    };
  }

  let occurrenceHeader = { id: 0, taskEnded: 0 };
  if (values.type === COMMUNICATION_TYPE.OCCURRENCE) {
    const occurrenceType = {
      ...values.occurrenceHeader.occurrenceType,
      filterByStatus: false,
      updaterId: 0,
      active: true,
    };

    delete occurrenceType.value;
    delete occurrenceType.label;
    delete occurrenceType.lowercaseLabel;

    occurrenceHeader = {
      ...occurrenceHeader,
      id:
        values.occurrenceHeader && values.occurrenceHeader.id
          ? values.occurrenceHeader.id
          : 0,
      occurrenceType: { ...occurrenceType },
      occurrenceHour: values.occurrenceHeader.occurrenceHour,
      occurrenceDateMilli: new Date(
        values.occurrenceHeader.occurrenceDate
      ).getTime(),
    };
  }

  let relatedQuestions = [];
  if (values.questions) {
    relatedQuestions = values.questions.map((question) => ({
      id: 0,
      communicationId: values.id ? values.id : 0,
      question: {
        id: 0,
        hashId: question.hashId,
        type: question.type.value,
        description: question.description,
        deleted: false,
        active: true,
        answers: getQuestionAnswers(question.answers),
        numberOfAnswer: 0,
      },
    }));
  }

  if (files) {
    filesId = files.map((file) =>
      file.uploadType === ATTACHMENT_TYPES.VIMEO
        ? {
            fileId: null,
            fileUrl: file.fileId,
            order: 0,
            communicationId: values.id,
            id: 0,
            fileType: file.uploadType,
            status: VIMEO_VIDEO_STATUS.IN_PROGRESS,
          }
        : {
            fileId: file.fileId,
            order: 0,
            communicationId: values.id,
            id: 0,
            fileType: file.uploadType,
          }
    );
  }
  if (files && filesAlreadyToUploaded.length) {
    const filesAlready = filesAlreadyToUploaded.map((file) => {
      if (file.fileType === ATTACHMENT_TYPES.VIMEO) {
        return {
          fileId: null,
          fileUrl: file.fileUrl,
          order: 0,
          communicationId: values.id,
          id: 0,
          fileType: file.fileType,
          status: file.status ? file.status : VIMEO_VIDEO_STATUS.IN_PROGRESS,
        };
      }
      if (file.fileType === ATTACHMENT_TYPES.YOUTUBE) {
        return {
          fileId: null,
          fileUrl: file.fileUrl,
          order: 0,
          communicationId: values.id,
          id: 0,
          fileType: file.fileType,
        };
      }
      return {
        fileId: file.fileId,
        order: 0,
        communicationId: values.id,
        id: 0,
        fileType: file.fileType,
      };
    });
    filesId = [...filesId, ...filesAlready];
  }
  const mutation = ` 
  mutation ($htmlContent: String!, $textContent: String, $title: String!){ 
    communicationSave(
        communication: 
            {
                id: ${values.id ? values.id : 0},
                editable: ${values.editable},
                title: $title,
                htmlContent: $htmlContent,
                content: $textContent,
                type: ${addDoubleQuotes(values.type)},
                scheduled: ${!!values.scheduled},
                removed: false,
                periodId: 0,
                updaterId: 0,
                approverId: 0,                
                creatorId: 0,
                deviceId: 0,
                forAll: false,
                hashId: ${
                  values.hashId
                    ? addDoubleQuotes(values.hashId)
                    : addDoubleQuotes(uuid())
                },
                sent: ${!!values.sent},
                createdAtMili: ${
                  values.createdAt ? values.createdAt.getTime() : 0
                },
                scheduledTo: ${values.scheduled ? values.scheduledTo : 0},
                dueDateMili: ${values.dueDate ? values.dueDate.getTime() : 0},
                sentAt: ${values.sentAt ? values.sentAt : 0},
                relatedObjects: ${JSON.stringify(recipients).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
                taskHeader: ${JSON.stringify(taskHeader).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
                examHeader: ${JSON.stringify(examHeader).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
                occurrenceHeader: ${JSON.stringify(occurrenceHeader).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
                planHeader: ${toStringify(planHeader)},
                relatedQuestions: ${JSON.stringify(relatedQuestions).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
             files: ${JSON.stringify(filesId).replace(/"([^(")"]+)":/g, '$1:')}
             visibleTo: "${values.visibleTo}"
            }
    ), {id}
  }`;
  return mutation;
}

export function communicationRemoveQuery(id) {
  const query = `mutation {communicationRemove(communicationId: ${id})}`;
  return query;
}

export function getCommunicationResultsViewedWrapper(communicationId) {
  return `{
  getCommunicationResultsViewedWrapper(communicationId: ${communicationId}) {
    communicationResultsDetail {
      studentId
      studentName
      classesNames
      classesNames
      responsibleName
      responsiblePhone
      responsibleEmail
      viewed
      previewDate
      viewedBy
      answer
      answerDate
    }
    communicationResultsResp {
      viewed
      notViewed
    }
    communicationResultsAlun {
      viewed
      notViewed
    }
  }
}
`;
}

export function taskCorrectionListByFilter(id) {
  const query = `{
  taskCorrectionListByFilter(taskId: ${id}) {
    id
    taskId
    student {
      id
      fullName
      filterByStatus
      updaterId
      active
      activeOnLoggedPeriod
      legacyId
      dateOfBirth
    }
    answer
    privateObs
    publicObs
    deliveryDate
    status
    taskAttachments {
      id
      fileId
      fileUrl
      name
      responsible {
        id
        fullName
        filterByStatus
        updaterId
        validateCpfOnSubmit
      }
      taskCorrectionId
      creationDate
    }
  }
}
`;
  return query;
}

export function taskCorrectionSave(status, privateObs, publicObs, task) {
  const listOfAttachments = task.taskAttachments.map((attachMent) => ({
    ...attachMent,
    responsible: {
      ...attachMent.responsible,
      chatUserId: attachMent.responsible.chatUserId
        ? attachMent.responsible.chatUserId
        : 0,
    },
  }));
  const query = `mutation {
  taskCorrectionSave(
    taskCorrections: [
      {
        id: 0
        taskId: ${task.taskId}
        student: {
          id: ${task.student.id}
          fullName: "${task.student.fullName}"
          filterByStatus: false
          updaterId: 0
          active: false
          activeOnLoggedPeriod: false
          legacyId: 0
          dateOfBirth: 0
        }
        privateObs: "${privateObs || ''}"
        publicObs: "${publicObs || ''}"
        deliveryDate: ${task.deliveryDate || 0}
        status: "${status}"
        taskAttachments: ${
          JSON.stringify(listOfAttachments).replace(/"([^(")"]+)":/g, '$1:') ||
          []
        }
      }
    ]
    taskEnded: false
  ) {
    id
  }
}`;
  return query;
}

export function taskEnd(task) {
  const mappedTask = task.map((item) => ({
    id: item.id,
    taskId: item.taskId,
    student: item.student,
    privateObs: item.privateObs,
    publicObs: item.publicObs,
    deliveryDate: item.deliveryDate,
    status: item.status,
    taskAttachments: item.taskAttachments.map((attachMent) => ({
      ...attachMent,
      responsible: {
        ...attachMent.responsible,
        chatUserId: attachMent.responsible.chatUserId
          ? attachMent.responsible.chatUserId
          : 0,
      },
    })),
  }));
  const query = `mutation {
  taskCorrectionSave(
    taskCorrections: ${JSON.stringify(mappedTask).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}
    taskEnded: true
  ) {
    id
  }
}`;

  return query;
}

export function getCommunicationResultsAnswers(communicationId, resultType) {
  const query = `{getCommunicationResultsAnswers(communicationId:${communicationId}, resultType:"${resultType}")
{answer, totalAnswered}}`;

  return query;
}

export function examCorrectionListByExamId(id) {
  return `{
  examCorrectionListByFilter(examId: ${id}) {
    id
    taskId
    student {
      id
      fullName
      filterByStatus
      updaterId
      active
      activeOnLoggedPeriod
      legacyId
      dateOfBirth
    }
    privateObs
    publicObs
    deliveryDate
    status
    grade
    taskAttachments {
      id
      fileId
      fileUrl
      name
      responsible {
        id
        fullName
        filterByStatus
        updaterId
        validateCpfOnSubmit               

      }
      taskCorrectionId
      creationDate
    }
  }
}`;
}

export function examCorrectionSave(status, grade, privateObs, publicObs, exam) {
  const mutation = `mutation {
  examCorrectionSave(
    examCorrections: [
      {
        id: 0
        taskId: ${exam.taskId}
        student: {
          id: ${exam.student.id}
          fullName: "${exam.student.fullName}"
          filterByStatus: false
          updaterId: 0
          active: false
          activeOnLoggedPeriod: false
          legacyId: 0
          dateOfBirth: 0
        }
        privateObs: "${privateObs || ''}"
        publicObs: "${publicObs || ''}"
        deliveryDate: ${exam.deliveryDate || 0}
        status: "${status}"
        grade: ${grade || 0}
        taskAttachments: ${
          JSON.stringify(exam.taskAttachments).replace(
            /"([^(")"]+)":/g,
            '$1:'
          ) || []
        }
      }
    ]
    examEnded: false
  ) {
    id
  }
}`;
  return mutation;
}

export function examEnd(task) {
  const mappedTask = task.map((item) => ({
    id: item.id,
    taskId: item.taskId,
    student: item.student,
    privateObs: item.privateObs,
    publicObs: item.publicObs,
    deliveryDate: item.deliveryDate,
    status: item.status,
    taskAttachments: item.taskAttachments,
    grade: item.grade,
  }));
  return `mutation {
  examCorrectionSave(
    examCorrections: ${JSON.stringify(mappedTask).replace(
      /"([^(")"]+)":/g,
      '$1:'
    )}
    examEnded: true
  ) {
    id
  }
}`;
}

export function communicationFindByTypeFilterQuery(filter) {
  const classes = filter.classes ? filter.classes.map(({ id }) => id) : [];
  const students = filter.students ? filter.students.map(({ id }) => id) : [];
  const employees = filter.employees
    ? filter.employees.map(({ id }) => id)
    : [];

  const getExamFields = `examHeader {
    id
    taskEnded
    teacher {
      id
      name
    }
    courseStep {
      course {
        id
        minNote
        maxNote
      }
    }
    subject {
      id
      name
    }
    evaluationWay { name }
    weight
    evaluationType
  }`;

  const getTaskFields = `taskHeader {
        taskEnded
        id
        teacher {
          id
          name
        }
        subject {
          id
          name
        }
      }`;

  const getEventHeader = `eventHeader {
          allDay
          local
          initialDate
          finalDate
          initialHour
          finalHour
  }`;

  const query = `query {
    communicationListByFilter(
      filter: {
        id: 0
        classes: ${JSON.stringify(classes).replace(/"([^(")"]+)":/g, '$1:')},
        students: ${JSON.stringify(students).replace(/"([^(")"]+)":/g, '$1:')},
        employees: ${JSON.stringify(employees).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        periodType: "${!filter.onlySent ? filter.periodType : ''}"
        initialPeriod: ${filter.initialPeriod.getTime()}
        finalPeriod: ${filter.finalPeriod.getTime()}
        communicationType: "${
          filter.communicationType ? filter.communicationType.value : ''
        }"
        onlySent: ${filter.onlySent}
        status: ${filter.status ? addQuotes(filter.status) : '""'}
      }
    ) {
      id
      editable
      title
      htmlContent
      content
      sent
      scheduled
      type
      updaterName
      creatorName
      createdAtMili
      sentAt
      dueDateMili
      scheduledTo
      scheduledToHour
      hashId
      timelineIntegrationStatus
      ${
        filter.communicationType &&
        filter.communicationType.value === COMMUNICATION_TYPE.EXAM
          ? getExamFields
          : ''
      }
      ${
        filter.communicationType &&
        filter.communicationType.value === COMMUNICATION_TYPE.ACTIVITY
          ? getTaskFields
          : ''
      }
       ${
         filter.communicationType && filter.communicationType.event
           ? getEventHeader
           : ''
       }
    }
  }
  `;
  return query;
}

export function communicationsByIds(ids) {
  return `query {
    communicationsByIds(ids: [${ids}]) {
      id
      title
      htmlContent
      type
      creatorId
      studentId
      anthropometricMeasurements {
        id
      }
      eventHeader {
          id
          allDay
          local
          initialDate
          finalDate
          initialHour
          finalHour
      }
    }
  }`;
}

export function communicationListForAnalysis() {
  return `
  {
    communicationListByFilter(
      filter: { 
        id:0
        communicationType: "${COMMUNICATION_TYPE.ANALYSIS}"
        shouldLoadAdtionalData: false
      }
    ) 
    {
      id
      createdAtMili
      sent
      classNames
      timelineIntegrationStatus
      relatedObjects{
          id,
          description
      }
    }
  }
  `;
}

export function sendCommunicationsByIds(idsToSend) {
  return ` 
  mutation { sendByIds(idsToSend: ${JSON.stringify(idsToSend).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )})
  }`;
}

export function approveCommunicationByIds(idsToApprove) {
  return ` 
  mutation { approveCommunicationByIds(ids: ${JSON.stringify(
    idsToApprove
  ).replace(/"([^(")"]+)":/g, '$1:')})
  }`;
}

export function disApproveCommunicationByIds(idsToDisapprove) {
  return ` 
  mutation { disApproveCommunicationByIds(ids: ${JSON.stringify(
    idsToDisapprove
  ).replace(/"([^(")"]+)":/g, '$1:')})
  }`;
}

export function communicationAnalysisSaveMutation(values) {
  const relatedObjects = [];
  relatedObjects.push({
    id: values.relatedObjects.value,
    type: RELATION_OBJECT_TYPE.STUDENT,
    quantity: 0,
  });

  const analysisItems = values.analysisItems
    ? values.analysisItems.map((item) => ({
        id: 0,
        analysisItem: {
          id: item.id,
          name: item.name,
          filterByStatus: false,
          updaterId: 0,
          active: true,
          order: 0,
        },
        analysisName: item.analysisName,
        analysisContent: item.analysisContent,
      }))
    : [];

  const mutation = `
  mutation {
    communicationSave(
        communication: 
            {
                id: ${values.id ? values.id : 0},
                editable: ${!values.sent},
                type: ${addDoubleQuotes(COMMUNICATION_TYPE.ANALYSIS)},
                title: "${values.title}"
                scheduled: false,
                removed: false,
                periodId: 0,
                updaterId: 0,
                approverId: 0,                
                creatorId: 0,
                deviceId: 0,
                forAll: false,
                hashId: ${addDoubleQuotes(uuid())},
                sent: ${values.sent},
                createdAtMili: ${values.date.getTime()},
                scheduledTo: 0,
                dueDateMili: 0,
                sentAt: ${new Date().getTime()},
                relatedObjects: ${JSON.stringify(relatedObjects).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
             visibleTo: "${AVAILABLE_TO.ONLY_RESPONSIBLES}",
             analysisItems: ${JSON.stringify(analysisItems).replace(
               /"([^(")"]+)":/g,
               '$1:'
             )}
            }
    ), {id}
  }

  `;

  return mutation;
}

export function communicationRemoveWithChildren(
  communicationId,
  removeChildren
) {
  return `mutation{ communicationRemoveWithChildren(communicationId:${communicationId}, removeChildren: ${removeChildren})}
`;
}

export function communicationCalendarSaveMutation(values) {
  const relatedObjects = values.relatedObjects.map((item) => ({
    id: item.id,
    description: item.description,
    type: item.type,
    quantity: item.quantity,
  }));

  const eventHeader = {
    repeat: false,
    daysRepeat: DAYS_REPEAT_STRING,
    inicialDateRepeat: 0,
    finalDateRepeat: 0,
  };

  if (values.repeat && values.daysRepeat) {
    eventHeader.repeat = values.repeat;
    eventHeader.inicialDateRepeat = values.inicialDateRepeat;
    eventHeader.finalDateRepeat = values.finalDateRepeat;
    eventHeader.daysRepeat = values.daysRepeat.toString().replace(/,/g, ';');
  }

  const lstNotifications = values.lstNotifications.map((notification) => ({
    id: notification.id,
    timeNotification: notification.timeNotification,
    typeNotification: notification.typeNotification,
  }));

  const mutation = `
  mutation ($title: String!, $htmlContent: String, $textContent: String, $local: String){
    communicationSave(
        communication: 
            {
                id: ${values.communication ? values.communication.id : 0},
                editable: true,
                title: $title,
                htmlContent: $htmlContent,
                content: $textContent,
                type: ${addDoubleQuotes(COMMUNICATION_TYPE.CALENDAR)},
                scheduled: false,
                removed: false,
                periodId: 0,
                updaterId: 0,
                approverId: 0,                
                creatorId: 0,
                deviceId: 0,
                forAll: false,
                hashId: ${addDoubleQuotes(uuid())},
                sent: true,
                createdAtMili: ${values.communication.createdAtMili || 0},
                scheduledTo: 0,
                dueDateMili: 0,
                sentAt: ${new Date().getTime()},
                relatedObjects: ${JSON.stringify(relatedObjects).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
             visibleTo: ${addQuotes(AVAILABLE_TO.ONLY_RESPONSIBLES)},
             eventHeader: {
                 id: ${values.id ? values.id : 0},
                 calendar:{ id: ${values.calendar.id}},
                 local: $local,
                 allDay: ${values.allDay},
                 initialDate: ${new Date(values.initialDate).getTime()},
                 initialDateText: ${addQuotes(
                   format(new Date(values.initialDate), 'yyyy-MM-dd')
                 )},
                 initialHour: ${addQuotes(values.initialHour)} ,
                 finalDate: ${new Date(values.finalDate).getTime()},
                 finalDateText: ${addQuotes(
                   format(new Date(values.finalDate), 'yyyy-MM-dd')
                 )},
                 finalHour: ${addQuotes(values.finalHour)},
                 repeat: ${!!eventHeader.repeat},
                 daysRepeat: ${addQuotes(eventHeader.daysRepeat)},
                 inicialDateRepeat: ${
                   values.inicialDateRepeat
                     ? new Date(values.inicialDateRepeat).getTime()
                     : 0
                 },
                finalDateRepeat: ${
                  values.finalDateRepeat
                    ? new Date(values.finalDateRepeat).getTime()
                    : 0
                },
                fatherCode: ${values.fatherCode || 0},
                attendanceConfirmation: ${values.attendanceConfirmation},
                saveAll: ${values.saveAll || false},
                lstNotifications: ${JSON.stringify(lstNotifications).replace(
                  /"([^(")"]+)":/g,
                  '$1:'
                )},
             }
            }
    ), {id}
  }

  `;

  return mutation;
}
